import { styled } from 'linaria/react';
import { breakpoints } from 'common/styles/breakpoints';
import { css } from 'linaria';

export const StmContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  padding: 0 3px;
  margin-bottom: var(--space-500);
  overflow: hidden;
  column-gap: var(--space-150);
  ${breakpoints.from.tablet} {
    grid-template-columns: repeat(4, 1fr);
    column-gap: var(--space-400);
  }
  ${breakpoints.from.desktop} {
    grid-template-columns: repeat(6, 1fr);
    height: auto !important;
    margin-bottom: var(--space-1000);
  }
  ${breakpoints.from.largeDesktop} {
    grid-template-columns: repeat(8, 1fr);
    column-gap: var(--space-400);
  }
  ${breakpoints.to.tablet} {
    height: 700px;
  }
`;

export const stmContainerOpened = css`
  margin-bottom: var(--space-950);
  overflow: initial;
`;

export const fadeButtonOpened = css`
  bottom: -36px !important;
`;

export const stmHeader = css`
  margin-top: var(--space-375);
`;
export const fadeContainer = css`
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: var(--layout-width);
  height: 78px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.0001) 0.61%,
    rgba(255, 255, 255, 0.81321) 37.33%,
    rgba(255, 255, 255, 1) 100%
  );
  pointer-events: none;
  ${breakpoints.from.tablet} {
    display: none;
  }
`;
